import { ComboBoxDoubleLineOption } from '../../../cdl/ComboBox/ComboBox';
import { formatDateTime } from '../../../common/helpers/formatDateTime.helper';
import { MiddleDotSeparator } from '../../../common/Separators/MiddleDotSeparator';
import { KeyPortHighlight } from '../../../keyport/KeyPortHighlight';
import type { SchedulePortOption } from '../PortDetailSelect';

import { ScheduleIndicator } from './ScheduleIndicator';

const isValidDateInput = (date: string) => !Number.isNaN(new Date(date).getTime());

interface PortOptionWithScheduleProps {
    option: SchedulePortOption;
}

export const PortOptionWithSchedule = ({ option }: PortOptionWithScheduleProps) => {
    const portCountryWithLocode = `${option.port.country.name} (${option.port.locCode})`;

    const formattedArrivalDate = isValidDateInput(option.scheduleEntry.eta)
        ? formatDateTime({
              date: option.scheduleEntry.eta,
              timeZoneId: option.scheduleEntry.timeZoneId,
          })
        : null;

    return (
        <ComboBoxDoubleLineOption
            title={option.label}
            description={
                <>
                    {portCountryWithLocode}
                    {formattedArrivalDate ? (
                        <>
                            <MiddleDotSeparator />
                            {formattedArrivalDate}
                        </>
                    ) : null}
                </>
            }
            leadingVisual={
                <ScheduleIndicator
                    isFirstScheduleStop={option.scheduleEntry.rank === 1}
                    isLastScheduleStop={option.scheduleEntry.rank === option.schedulesLength}
                />
            }
            titleSuffix={<KeyPortHighlight portId={option.port.id} vesselId={option.vesselId} />}
        />
    );
};
